export default __webpack_public_path__ + "static/pic1-4d2530f1104b19bd9f9a38799ae0789a.png";